import type { App } from 'vue'
import VxeUI from 'vxe-pc-ui'
import VxeUITable from 'vxe-table'
import 'vxe-pc-ui/lib/style.css'
import 'vxe-table/lib/style.css'
import '@/styles/vxe-table-antd.less'

export function setupVxeTable(app: App) {
  app.use(VxeUI).use(VxeUITable)
}
